import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Input,
  NativeSelect,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { useRecoilState, useSetRecoilState } from "recoil";
import { transactionClicked, showloader } from "../store/gloabalState";
import useNotify from "../utils/useNotify";
import { DateConvert } from "../utils/dateConverter";
import SearchSelect from "../components/searchAndSelect";
import DroppedStage from "../components/DroppedStage";
import {
  updateTransactionRes,
  getTransactionsDetail,
  getOrgsDetails,
} from "../services/httpCalls";
import { useNavigate } from "react-router-dom";
import TransactionFileUpload from "../components/TransactionFileUpload";
import { cleanObject } from "../utils/onboarding/clean-object";
import { ibanRegex, onlyNumericDigitsWithDecimalRegex, swiftRegex, udinRegex, utrRegex } from "../config/globalVar";

export default function UpdateTransaction() {
  const [transactionId, setTransactionId] = useRecoilState(transactionClicked);
  const [transactionDetail, setTransactionDetail] = useState();
  const [stageListLeft, setStageListLeft] = useState([]);
  const [fundReqBank, setFundReqBank] = useState("");
  const [showDroppedTxnModal, setShowDroppedTxnModal] = useState(false);
  const [errors, setErrors] = useState({
    amount: false,
    tdsPercentage: false,
    fxConversionRate: false,
    commissionCharges: false,
    swiftCharges: false,
    "15CbCharges": false,
    gstAmount: false,
    utr: false,
    udin: false,
    netPayableAmount: false,
    vendorBankName: false,
    vendorAccountNumber: false,
    vendorIbanCode: false, 
    vendorSwiftCode: false
  });

  const navigate = useNavigate();
  const [adBankdetails, setAdBankdetails] = useState([]);
  const [type, setType] = useState("")
  const [updateForm, setUpdateForm] = useState({
    opsMemberAssigned: null,
    assignedOpsMemberId: null,
    vendorId: null,
    nextStage: null,
    currencyCode: null,
    amount: null,
    caAssignedId: null,
    caAssignedName: null,
    purposeCode: null,
    tdsApplicable: false,
    tdsPercentage: 0,
    grossUp: false,
    fxConversionRate: 0,
    swiftCharges: 0,
    "15CbCharges": 0,
    commissionCharges: 0,
    actUsedForFts: null,
    vendorName: null,
    vendorBankName: null,
    vendorBankAddress: null,
    vendorAccountNumber: null,
    vendorSwiftCode: null,
    vendorIbanCode: null,
    purposeDescriptionAsPerRBI: null,
    stageName: null,
    isAgreementNeeded: false,
    transactionVelocity: false,
    notAnAdvancePayment: false,
    isPurposeAllowed: false,
    utr: null,
    udin: null,
    netPayableAmount: null,
    gstAmount: 0,
    dropReasonGroup: null,
    reasonDescription: null,
    adBankId: null,
    transactionType: null
  });
  const setShowLoader = useSetRecoilState(showloader);
  let notify = useNotify();

  const mapToFunc = async (res) => {
    let copyUpdateForm = updateForm;
    if (res.assignedOpsMember) {
      copyUpdateForm.opsMemberAssigned = res.assignedOpsMember;
      copyUpdateForm.assignedOpsMemberId = `${res.assignedOpsMemberId}`;
    }
    if (res.vendorName && res.vendorId) {
      copyUpdateForm.vendorName = res.vendorName;
      copyUpdateForm.vendorId = res.vendorId;
    }
    if (res.bankName) {
      copyUpdateForm.bankName = res.bankName;
    }
    if (res.currencyCode) {
      copyUpdateForm.currencyCode = res.currencyCode;
    }
    if (res.amount) {
      copyUpdateForm.amount = res.amount;
    }
    if (res.purposeCodeAsPerRBI) {
      copyUpdateForm.purposeCode = res.purposeCodeAsPerRBI;
      copyUpdateForm.purposeDescriptionAsPerRBI =
        res.purposeDescriptionAsPerRBI;
    }
    if (res.vendorBankName) {
      copyUpdateForm.vendorBankName = res.vendorBankName;
    }
    if (res.vendorAccountNumber) {
      copyUpdateForm.vendorAccountNumber = res.vendorAccountNumber;
    }
    if (res.vendorSwiftCode) {
      copyUpdateForm.vendorSwiftCode = res.vendorSwiftCode;
    }
    if (res.vendorIbanCode) {
      copyUpdateForm.vendorIbanCode = res.vendorIbanCode;
    }
    if (res.ftsPercentage) {
      copyUpdateForm.tdsPercentage = res.ftsPercentage;
    }
    if (res.fxConversionRate) {
      copyUpdateForm.fxConversionRate = res.fxConversionRate;
    }
    if (res.swiftCharges) {
      copyUpdateForm.swiftCharges = res.swiftCharges;
    }
    if (res.cb15Charges) {
      copyUpdateForm["15CbCharges"] = res.cb15Charges;
    }
    if (res.actUsedForFts) {
      copyUpdateForm.actUsedForFts = res.actUsedForFts;
    }
    if (res.grossUp) {
      copyUpdateForm.grossUp = res.grossUp;
    }
    if (res.isFtsApplicable) {
      copyUpdateForm.tdsApplicable = res.isFtsApplicable;
    }
    if (res.charteredAccountantName) {
      copyUpdateForm.caAssignedName = res.charteredAccountantName;
      copyUpdateForm.caAssignedId = res.charteredAccountantId;
    }
    if (res.miscellaneousCharges) {
      copyUpdateForm.commissionCharges = res.miscellaneousCharges;
    }
    if (res.stage) {
      copyUpdateForm.stageName = res.stage;
    }
    if (res.udin) {
      copyUpdateForm.udin = res.udin;
    }
    if (res.utr) {
      copyUpdateForm.utr = res.utr;
    }
    if (res.isAgreementNeeded) {
      copyUpdateForm.isAgreementNeeded = res.isAgreementNeeded;
    }
    if (res.isPurposeAllowed) {
      copyUpdateForm.isPurposeAllowed = res.isPurposeAllowed;
    }
    if (res.notAnAdvancePayment) {
      copyUpdateForm.notAnAdvancePayment = res.notAnAdvancePayment;
    }
    if (res.transactionVelocity) {
      copyUpdateForm.transactionVelocity = res.transactionVelocity;
    }
    if (res.netPayableAmount) {
      copyUpdateForm.netPayableAmount = res.netPayableAmount;
    }
    if (res.vendorBankAddress) {
      copyUpdateForm.vendorBankAddress = res.vendorBankAddress;
    }
    if (res.gstAmount) {
      copyUpdateForm.gstAmount = res.gstAmount;
    }

    if (res?.adBankId) {
      copyUpdateForm.adBankId = res?.adBankId;
    }

    await setUpdateForm(copyUpdateForm);
  };


const hasSpecialCharacters = (value) => {
  const specialCharRegex = /[^a-zA-Z0-9\s.]/g;
  return specialCharRegex.test(value);
};

  useEffect(() => {


    async function getTransactionDetail(transactionId) {
      setShowLoader(true);
      if (transactionId) {
        getTransactionsDetail(transactionId).then((res) => {
          orgDetailsFetch(res.organisationId);
          setTransactionDetail(res);
          mapToFunc(res);
          let flag = false;
          let list_ = [];
          res.stageList.forEach((elem) => {
            if (flag) {
              list_.push(elem);
              return;
            }
            if (elem.name === res.stage) {
              flag = true;
              return;
            }
          });
          setType(res.transactionType)
          setStageListLeft(list_);
          setShowLoader(false);
        });
      } else {
        let url = window.location.pathname;
        url = url.split("/");
        url = url[2];
        setTransactionId(url);
        getTransactionDetail(url);
        setShowLoader(false);
      }
    }
    getTransactionDetail(transactionId);
    async function orgDetailsFetch(orgId) {
      await getOrgsDetails(orgId).then((res) => {
        if (res.adBankDetailList) {
          setAdBankdetails(res.adBankDetailList);
          res.adBankDetailList.map((item) => {
            if (item.isPrimaryAccount === true) {
              setFundReqBank(item.bankName);
            }
          });
        } else {
          res.bankDetailList.map((item) => {
            if (item.isPrimaryAccount === true) {
              setFundReqBank(item.bankName);
            }
          });
        }
      });
    }
  }, []);

  const updateTransactionCall = async (e) => {
    e.preventDefault();

    if(updateForm?.amount && (updateForm.amount < 0 || updateForm.amount.length > 13)){
      setErrors((err) => ({
          ...err,
          amount: true
      }))
      return;
    } 
    if(updateForm?.tdsPercentage && (updateForm.tdsPercentage < 0 || updateForm.tdsPercentage > 100 || updateForm.amount.length > 13)){
      setErrors((err) => ({
          ...err,
          tdsPercentage: true
      }))
      return;
    }
    if(updateForm?.netPayableAmount && (updateForm.netPayableAmount < 0 || updateForm.netPayableAmount.length > 13)){
      setErrors((err) => ({
          ...err,
          netPayableAmount: true
      }))
      return;
    }
    if(updateForm?.fxConversionRate && (updateForm.fxConversionRate < 0 || updateForm.fxConversionRate.length > 13)){
      setErrors((err) => ({
          ...err,
          fxConversionRate: true
      }))
      return;
    } 
    if(updateForm?.swiftCharges && (updateForm.swiftCharges < 0 || updateForm.swiftCharges.length > 13)){
      setErrors((err) => ({
          ...err,
          swiftCharges: true
      }))
      return;
    } 
    if(updateForm?.["15CbCharges"] && (updateForm["15CbCharges"] < 0 || updateForm["15CbCharges"].length > 13)){
      setErrors((err) => ({
          ...err,
          "15CbCharges": true
      }))
      return;
    } 
    if(updateForm?.commissionCharges && (updateForm.commissionCharges < 0 || updateForm.commissionCharges.length > 13)){
      setErrors((err) => ({
          ...err,
          commissionCharges: true
      }))
      return;
    }
    if(updateForm?.gstAmount && (updateForm.gstAmount < 0 || updateForm.gstAmount.length > 13)){
      setErrors((err) => ({
          ...err,
          gstAmount: true
      }))
      return;
    }
    if(updateForm?.utr && (updateForm.utr < 0 || updateForm.utr.length > 13)){
      setErrors((err) => ({
          ...err,
          utr: true
      }))
      return;
    }
    if(updateForm?.udin && (updateForm.udin < 0 || updateForm.udin.length > 18)){
      setErrors((err) => ({
          ...err,
          udin: true
      }))
      return;
    }
    if(updateForm?.vendorBankName &&  (updateForm.vendorBankName.length > 500)){
      setErrors((err) => ({
          ...err,
          vendorBankName: true
      }))
      return;
    }
    if(updateForm?.vendorAccountNumber &&  updateForm.vendorAccountNumber.length > 20){
      setErrors((err) => ({
          ...err,
          vendorAccountNumber: true
      }))
      return;
    }
    if(updateForm?.vendorIbanCode &&  updateForm.vendorIbanCode.length > 30){
      setErrors((err) => ({
          ...err,
          vendorIbanCode: true
      }))
      return;
    }if(updateForm?.vendorSwiftCode &&  updateForm.vendorSwiftCode.length > 15){
      setErrors((err) => ({
          ...err,
          vendorSwiftCode: true
      }))
      return;
    }

    if(Object.values(errors).some(error => error === true)){
      return;
    }

    setShowLoader(true);
    if (updateForm.nextStage === "FUND_REQUESTED") {
      if (
        !updateForm.fxConversionRate > 0 ||
        !updateForm.swiftCharges > 0 ||
        // !updateForm["15CbCharges"] > 0 ||
        !updateForm.commissionCharges > 0 ||
        !updateForm.gstAmount > 0 ||
        !updateForm.netPayableAmount > 0
      ) {
        notify.error(
          "FX Conversion Rate, SWIFT Charges, 15CB Charges, Commission Charges, Net Payable Amount and GST Amount cannot be 0"
        );
        setShowLoader(false);
        return false;
      }
    }
    // if (type === "A2" && !updateForm["15CbCharges"] > 0) {
    //   notify.error(
    //     "15CB Charges cannot be 0 for A2 transactions."
    //   );
    //   setShowLoader(false);
    //   return false;
    // }
    let cleanUpdateForm = cleanObject(updateForm)
    updateTransactionRes(cleanUpdateForm, transactionId)
      .then((res) => {
        notify.success("Updated the transaction data!");
        setShowLoader(false);
        navigate(-1);
      })
      .catch(() => {
        notify.error("Not able to Update the transaction data!");
        setShowLoader(false);
      });
  };

  const selectSearchData = (e, elemName, elemId) => {
    if (elemId === "currencyCode") {
      setUpdateForm({ ...updateForm, [elemId]: `${e}` });
    } else if (elemId === "purposeCode") {
      setUpdateForm({
        ...updateForm,
        purposeDescriptionAsPerRBI: e.paymentPurposeDescriptionAsPerRBI,
        paymentPurposeGroupAsPerRBI: e.paymentPurposeGroupAsPerRBI,
        purposeCodeAsPerRBI: e.paymentPurposeCodeAsPerRBI,
        purposeCode: e.paymentPurposeCodeAsPerRBI,
        // transactionType: type
      });
    } else {
      setUpdateForm({ ...updateForm, [elemName]: e.name, [elemId]: `${e.id}` });
    }
  };

  useEffect(() => {
    if (type === "A1") {
      setUpdateForm({ ...updateForm, ["15CbCharges"]: 0, transactionType: "A1" });
    }else{
      setUpdateForm({ ...updateForm, transactionType: "A2" });
    }
  }, [type])


  return (
    <Box sx={{ padding: "1rem" }}>
      <Typography variant="h5" sx={{ paddingBottom: "1rem", fontWeight: 400 }}>
        Update Transaction - <b>{transactionId}</b>
      </Typography>

      {transactionDetail && (
        <Box
          component="form"
          validate
          onSubmit={(e) => updateTransactionCall(e)}
        >
          <Grid container spacing={2}>
            <Grid item xs={6} sx={{ paddingLeft: "0 !important" }}>
              <Box
                sx={{
                  border: "1px solid #a2a2a2",
                  borderRadius: "4px",
                  padding: "1rem",
                  height: "100%",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: ".5rem",
                    color: "#4e4b4b",
                    borderBottom: ".5px solid",
                    marginBottom: "1rem",
                  }}
                >
                  Customer Details
                </Typography>
                <FormControl
                  readOnly
                  disabled
                  variant="standard"
                  sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                >
                  <InputLabel htmlFor="name">Customer Name</InputLabel>
                  <Input
                    value={
                      transactionDetail.customerName
                        ? transactionDetail.customerName
                        : "-"
                    }
                    id="name"
                    sx={{ width: "100%" }}
                  />
                </FormControl>
                <FormControl
                  variant="standard"
                  disabled
                  readOnly
                  required
                  sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                >
                  <InputLabel htmlFor="initiationDate">
                    Initiated Date
                  </InputLabel>
                  <Input
                    id="initiationDate"
                    value={
                      transactionDetail.initiationDate
                        ? DateConvert(transactionDetail.initiationDate)
                        : "-"
                    }
                    sx={{ width: "100%" }}
                  />
                </FormControl>
                <SearchSelect
                  selectSearchData={selectSearchData}
                  label={"Ops Member Assigned"}
                  name={"opsMemberAssigned"}
                  id={"assignedOpsMemberId"}
                  value={
                    updateForm.opsMemberAssigned !== null
                      ? updateForm.opsMemberAssigned
                      : ""
                  }
                />
                <FormControl
                  variant="standard"
                  readOnly
                  sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                >
                  <InputLabel htmlFor="stageName">Current Stage</InputLabel>
                  <Input
                    id="stageName"
                    value={
                      updateForm.stageName !== null ? updateForm.stageName : ""
                    }
                    sx={{ width: "100%" }}
                  />
                </FormControl>

                {/* {stageListLeft.length ? ( */}
                <FormControl
                  variant="standard"
                  sx={{
                    width: "300px",
                    display: `block`,
                    marginTop: ".5rem",
                  }}
                >
                  <InputLabel htmlFor="nextStage" shrink>
                    New Stage
                  </InputLabel>
                  <NativeSelect
                    id="nextStage"
                    disabled={updateForm.stageName === "DROPPED" ? true : false}
                    sx={{ padding: ".4rem", width: "100%" }}
                    onChange={(e) => {
                      if (e.target.value === "DROPPED") {
                        setShowDroppedTxnModal(true);
                        setUpdateForm({
                          ...updateForm,
                          nextStage: e.target.value,
                        });
                      } else {
                        setShowDroppedTxnModal(false);
                        setUpdateForm({
                          ...updateForm,
                          [e.target.id]:
                            e.target.value === "" ? null : e.target.value,
                        });
                      }
                    }}
                    value={
                      updateForm?.nextStage !== null
                        ? updateForm?.nextStage
                        : ""
                    }
                  >
                    <option value={""}>--Select--</option>
                    {stageListLeft?.map((stage, i) => {
                      return (
                        <option value={stage?.name} key={i}>
                          {stage?.stageName}
                        </option>
                      );
                    })}
                    {fundReqBank?.toUpperCase().trim().includes("SBM") && (
                      <option value={"FUND_REQUESTED"}>
                        {"Fund Requested"}
                      </option>
                    )}
                    {<option value={"DROPPED"}>{"Dropped"}</option>}
                  </NativeSelect>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={6} sx={{ paddingRight: "0 !important" }}>
              <Box
                sx={{
                  border: "1px solid #a2a2a2",
                  borderRadius: "4px",
                  padding: "1rem",
                  height: "100%",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: ".5rem",
                    color: "#4e4b4b",
                    borderBottom: ".5px solid",
                    marginBottom: "1rem",
                  }}
                >
                  Vendor Details
                </Typography>
                <SearchSelect
                  selectSearchData={selectSearchData}
                  label={"Vendor Name"}
                  name={"vendorName"}
                  id={"vendorId"}
                  value={
                    updateForm.vendorName !== null ? updateForm.vendorName : ""
                  }
                />
                <FormControl
                  variant="standard"
                  sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                  error={errors.vendorBankName}
                >
                  <InputLabel htmlFor="vendorBankName">Bank Name</InputLabel>
                  <Input
                    id="vendorBankName"
                    onChange={(e) =>{
                      setUpdateForm({
                        ...updateForm,
                        [e.target.id]: e.target.value,
                      })

                      if(hasSpecialCharacters(e.target.value)){
                        setErrors((errors) => ({
                          ...errors,
                          vendorBankName:true
                        }))
                      } else {
                        setErrors((errors) => ({
                          ...errors,
                          vendorBankName:false
                        }))
                      }
                    }      
                    }
                    value={
                      updateForm.vendorBankName !== null
                        ? updateForm.vendorBankName
                        : ""
                    }
                    sx={{ width: "100%" }}
                    inputProps={{ maxLength: 100 }}
                  />
                  {errors.vendorBankName && <FormHelperText>please enter a proper value!</FormHelperText>}
                </FormControl>
                <FormControl
                  variant="standard"
                  sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                >
                  <InputLabel htmlFor="vendorBankAddress">
                    Bank Adress
                  </InputLabel>
                  <Input
                    id="vendorBankAddress"
                    onChange={(e) =>{
                      setUpdateForm({
                        ...updateForm,
                        [e.target.id]: e.target.value,
                      })
                    }
                    }
                    value={updateForm.vendorBankAddress}
                    sx={{ width: "100%" }}
                    inputProps={{ maxLength: 100 }}
                  />
                </FormControl>
                <FormControl
                  variant="standard"
                  sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                  error={errors.vendorAccountNumber}
                >
                  <InputLabel htmlFor="vendorAccountNumber">
                    Vendor Account Number
                  </InputLabel>
                  <Input
                    id="vendorAccountNumber"
                    onChange={(e) => {        
                      setUpdateForm({
                        ...updateForm,
                        [e.target.id]: e.target.value,
                      })

                      if(hasSpecialCharacters(e.target.value)){
                        setErrors((errors) => ({
                          ...errors,
                          vendorAccountNumber:true
                        }))
                      } else {
                        setErrors((errors) => ({
                          ...errors,
                          vendorAccountNumber:false
                        }))
                      }
                    }
                    }
                    value={
                      updateForm.vendorAccountNumber !== null
                        ? updateForm.vendorAccountNumber
                        : ""
                    }
                    sx={{ width: "100%" }}
                    inputProps={{ maxLength: 100 }}
                  />
                  {errors.vendorAccountNumber && <FormHelperText>please enter a proper value!</FormHelperText>}
                </FormControl>
                <FormControl
                  variant="standard"
                  sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                  error={errors.vendorSwiftCode}
                >
                  <InputLabel htmlFor="vendorSwiftCode">
                    Vendor Swift Code
                  </InputLabel>
                  <Input
                    id="vendorSwiftCode"
                    onChange={(e) => {
                      setUpdateForm({
                        ...updateForm,
                        [e.target.id]: e.target.value,
                      })

                      if(hasSpecialCharacters(e.target.value) || !(swiftRegex).test(e.target.value)){
                        setErrors((errors) => ({
                          ...errors,
                          vendorSwiftCode:true
                        }))
                      } else {
                        setErrors((errors) => ({
                          ...errors,
                          vendorSwiftCode:false
                        }))
                      }
                    }
                  }
                    value={
                      updateForm.vendorSwiftCode !== null
                        ? updateForm.vendorSwiftCode
                        : ""
                    }
                    sx={{ width: "100%" }}
                    inputProps={{ maxLength: 100 }}
                  />
                {errors.vendorSwiftCode && <FormHelperText>please enter a proper value!</FormHelperText>}
                </FormControl>
                <FormControl
                  variant="standard"
                  sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                  error={errors.vendorIbanCode}
                >
                  <InputLabel htmlFor="vendorIbanCode">Vendor IBAN</InputLabel>
                  <Input
                    id="vendorIbanCode"
                    value={
                      updateForm.vendorIbanCode !== null
                        ? updateForm.vendorIbanCode
                        : ""
                    }
                    onChange={(e) => {                    
                      setUpdateForm({
                        ...updateForm,
                        [e.target.id]: e.target.value,
                      })

                      if(hasSpecialCharacters(e.target.value) || !(ibanRegex).test(e.target.value)){
                        setErrors((errors) => ({
                          ...errors,
                          vendorIbanCode:true
                        }))
                      } else {
                        setErrors((errors) => ({
                          ...errors,
                          vendorIbanCode:false
                        }))
                      }
                    }
                  }
                    sx={{ width: "100%" }}
                    inputProps={{ maxLength: 100 }}
                  />
                  {errors.vendorIbanCode && <FormHelperText>please enter a proper value!</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            sx={{
              border: "1px solid #a2a2a2",
              borderRadius: "4px",
              padding: "1rem",
              marginTop: "1rem",
              marginBottom: "4rem",
            }}
          >
            <Grid item xs={12} sx={{ padding: "0 !important" }}>
              <Typography
                variant="h6"
                sx={{
                  paddingBottom: ".5rem",
                  color: "#4e4b4b",
                  borderBottom: ".5px solid",
                  marginBottom: "1rem",
                }}
              >
                Transaction Details
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <SearchSelect
                selectSearchData={selectSearchData}
                label={"Currency"}
                id={"currencyCode"}
                required={updateForm.nextStage === "CB15" ? true : false}
                value={
                  transactionDetail?.currencyCode
                    ? transactionDetail?.currencyCode
                    : ""
                }
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                error={errors.amount}
              >
                <InputLabel htmlFor="amount">Amount</InputLabel>
                <Input
                  id="amount"
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      [e.target.id]: e.target.value,
                    })

                    if(!onlyNumericDigitsWithDecimalRegex.test(e.target.value)){
                      setErrors((errors) => ({
                        ...errors,
                        amount:true
                      }))
                    } else {
                      setErrors((errors) => ({
                        ...errors,
                        amount:false
                      }))
                    }
                  }

                  }
                  value={updateForm?.amount ? updateForm.amount : ""}
                  sx={{ width: "100%" }}
                  required={updateForm.nextStage === "CB15" ? true : false}
                  inputProps={{ maxLength: 100 }}
                />
                {errors.amount && <FormHelperText>please enter a proper value!</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <SearchSelect
                selectSearchData={selectSearchData}
                label={"CA Selected"}
                required={updateForm.nextStage === "CB15" ? true : false}
                name={"caAssignedName"}
                id={"caAssignedId"}
                value={
                  updateForm.caAssignedName !== null
                    ? updateForm.caAssignedName
                    : ""
                }
              />
            </Grid>
            <Grid item xs={6}>
              <SearchSelect
                selectSearchData={selectSearchData}
                label={"Purpose Code"}
                id={"purposeCode"}
                required={false}
                value={
                  updateForm?.purposeCode &&
                  `${updateForm?.purposeCode}-${updateForm?.purposeDescriptionAsPerRBI}`
                }
                type={type}
                setType_={setType}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel id="tdsApplicable" sx={{ fontSize: "12px" }}>
                  TDS Applicable
                </FormLabel>
                <RadioGroup
                  id="tdsApplicable"
                  aria-labelledby="tdsApplicable"
                  sx={{ display: "flex", width: "300px", flexDirection: "row" }}
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      tdsApplicable: e.target.value,
                    });
                  }}
                  value={
                    updateForm.tdsApplicable !== null
                      ? updateForm.tdsApplicable
                      : ""
                  }
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="True"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="False"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                error={errors.tdsPercentage}
              >
                <InputLabel htmlFor="tdsPercentage">TDS %</InputLabel>
                <Input
                  id="tdsPercentage"
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      [e.target.id]: e.target.value,
                    })

                    if(hasSpecialCharacters(e.target.value) || !(onlyNumericDigitsWithDecimalRegex).test(e.target.value)){
                      setErrors((errors) => ({
                        ...errors,
                        tdsPercentage:true
                      }))
                    } else {
                      setErrors((errors) => ({
                        ...errors,
                        tdsPercentage:false
                      }))
                    }
                  }
                }
                  value={
                    updateForm.tdsPercentage !== null
                      ? updateForm.tdsPercentage
                      : ""
                  }
                  sx={{ width: "100%" }}
                  inputProps={{ maxLength: 100 }}
                />
                {errors.tdsPercentage && <FormHelperText>please enter a proper value!</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                error={errors.netPayableAmount}
              >
                <InputLabel htmlFor="netPayableAmount" shrink>
                  Net Paybable Amount
                </InputLabel>
                <Input
                  id="netPayableAmount"
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      [e.target.id]: e.target.value,
                    });

                    if(!(onlyNumericDigitsWithDecimalRegex).test(e.target.value)){
                      setErrors((errors) => ({
                        ...errors,
                        netPayableAmount:true
                      }))
                    } else {
                      setErrors((errors) => ({
                        ...errors,
                        netPayableAmount:false
                      }))
                    }
                  }}
                  value={updateForm.netPayableAmount}
                  sx={{ width: "100%" }}
                  inputProps={{ maxLength: 100 }}
                />
                {errors.netPayableAmount && <FormHelperText>please enter a proper value!</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel id="grossUp" sx={{ fontSize: "12px" }}>
                  Gross Up
                </FormLabel>
                <RadioGroup
                  id="grossUp"
                  aria-labelledby="grossUp"
                  sx={{ display: "flex", width: "300px", flexDirection: "row" }}
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      grossUp: e.target.value,
                    });
                  }}
                  value={updateForm.grossUp}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="True"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="False"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              >
                <InputLabel htmlFor="actUsedForFts" shrink>
                  Tax Act Used
                </InputLabel>
                <NativeSelect
                  id="actUsedForFts"
                  sx={{ padding: ".4rem", width: "100%" }}
                  onChange={(e) =>
                    setUpdateForm({
                      ...updateForm,
                      [e.target.id]: e.target.value,
                    })
                  }
                  value={
                    updateForm?.actUsedForFts ? updateForm?.actUsedForFts : ""
                  }
                >
                  <option value="">--Select--</option>
                  <option value="itact">IT Act</option>
                  <option value="dtaa">DTAA</option>
                </NativeSelect>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                error={errors.fxConversionRate}
              >
                <InputLabel htmlFor="fxConversionRate">
                  FX Conversion Rate
                </InputLabel>
                <Input
                  id="fxConversionRate"
                  required={
                    updateForm.nextStage === "FUND_REQUESTED" ? true : false
                  }
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      [e.target.id]: e.target.value,
                    })

                    if(hasSpecialCharacters(e.target.value) || !onlyNumericDigitsWithDecimalRegex.test(e.target.value)){
                      setErrors((errors) => ({
                        ...errors,
                        fxConversionRate:true
                      }))
                    } else {
                      setErrors((errors) => ({
                        ...errors,
                        fxConversionRate:false
                      }))
                    }
                  }
                }
                  value={updateForm.fxConversionRate}
                  sx={{ width: "100%" }}
                  inputProps={{ maxLength: 100 }}
                />
                {errors.fxConversionRate && <FormHelperText>please enter proper value!</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                error={errors.swiftCharges}
              >
                <InputLabel htmlFor="swiftCharges">SWIFT Charges</InputLabel>
                <Input
                  id="swiftCharges"
                  required={
                    updateForm.nextStage === "FUND_REQUESTED" ? true : false
                  }
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      [e.target.id]: e.target.value,
                    })

                    if(hasSpecialCharacters(e.target.value) || !onlyNumericDigitsWithDecimalRegex.test(e.target.value)){
                      setErrors((errors) => ({
                        ...errors,
                        swiftCharges:true
                      }))
                    } else {
                      setErrors((errors) => ({
                        ...errors,
                        swiftCharges:false
                      }))
                    }
                  }
                  }
                  value={
                    updateForm.swiftCharges !== null
                      ? updateForm.swiftCharges
                      : ""
                  }
                  sx={{ width: "100%" }}
                  inputProps={{ maxLength: 100 }}
                />
                {errors.swiftCharges && <FormHelperText>please enter proper value!</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                error={errors["15CbCharges"]}
              >
                <InputLabel htmlFor="15CbCharges">15 CB Charges</InputLabel>
                <Input
                  id="15CbCharges"
                  required={
                    updateForm.nextStage === "FUND_REQUESTED" || transactionDetail.transactionType === "A2" ? true : false
                  }
                  onChange={(e) =>{
                    setUpdateForm({
                      ...updateForm,
                      [e.target.id]: e.target.value,
                    })

                    if(hasSpecialCharacters(e.target.value) || !onlyNumericDigitsWithDecimalRegex.test(e.target.value)){
                      setErrors((errors) => ({
                        ...errors,
                        "15CbCharges":true
                      }))
                    } else {
                      setErrors((errors) => ({
                        ...errors,
                        "15CbCharges":false
                      }))
                    }
                  }
                  }
                  readOnly={type === "A1" ? true : false}
                  value={updateForm["15CbCharges"]}
                  sx={{ width: "100%" }}
                  inputProps={{ maxLength: 100 }}
                />
                {errors["15CbCharges"] && <FormHelperText>please enter proper value!</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                error={errors.commissionCharges}
              >
                <InputLabel htmlFor="commissionCharges">
                  Commission Charges
                </InputLabel>
                <Input
                  id="commissionCharges"
                  required={
                    updateForm.nextStage === "FUND_REQUESTED" ? true : false
                  }
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      [e.target.id]: e.target.value,
                    })
                    if(hasSpecialCharacters(e.target.value)){
                      setErrors((errors) => ({
                        ...errors,
                        commissionCharges:true
                      }))
                    } else {
                      setErrors((errors) => ({
                        ...errors,
                        commissionCharges:false
                      }))
                    }
                  }
                  }
                  value={
                    updateForm.commissionCharges !== null
                      ? updateForm.commissionCharges
                      : ""
                  }
                  sx={{ width: "100%" }}
                  inputProps={{ maxLength: 100 }}
                />
                {errors.commissionCharges && <FormHelperText>please enter a proper value!</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                error={errors.gstAmount}
              >
                <InputLabel htmlFor="gstAmount">GST Amount</InputLabel>
                <Input
                  id="gstAmount"
                  required={
                    updateForm.nextStage === "FUND_REQUESTED" ? true : false
                  }
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      [e.target.id]: e.target.value,
                    })

                    if(hasSpecialCharacters(e.target.value) || !onlyNumericDigitsWithDecimalRegex.test(e.target.value)){
                      setErrors((errors) => ({
                        ...errors,
                        gstAmount:true
                      }))
                    } else {
                      setErrors((errors) => ({
                        ...errors,
                        gstAmount:false
                      }))
                    }
                  }
                }
                  value={
                    updateForm.gstAmount !== null ? updateForm.gstAmount : ""
                  }
                  sx={{ width: "100%" }}
                  inputProps={{ maxLength: 100 }}
                />
                {errors.gstAmount && <FormHelperText>please enter a proper value!</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                error={errors.utr}
              >
                <InputLabel htmlFor="utr">UTR</InputLabel>
                <Input
                  id="utr"
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      [e.target.id]: e.target.value,
                    })

                    if(hasSpecialCharacters(e.target.value) || !(utrRegex).test(e.target.value)){
                      setErrors((errors) => ({
                        ...errors,
                        utr:true
                      }))
                    } else {
                      setErrors((errors) => ({
                        ...errors,
                        utr:false
                      }))
                    }
                  }
                }
                  value={updateForm.utr ? updateForm.utr : ""}
                  sx={{ width: "100%" }}
                  inputProps={{ maxLength: 100 }}
                />
                {errors.utr && <FormHelperText>please enter a proper value!</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                error={errors.udin}
              >
                <InputLabel htmlFor="udin">UDIN</InputLabel>
                <Input
                  id="udin"
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      [e.target.id]: e.target.value,
                    })

                    if(hasSpecialCharacters(e.target.value) || !(udinRegex).test(e.target.value)){
                      setErrors((errors) => ({
                        ...errors,
                        udin:true
                      }))
                    } else {
                      setErrors((errors) => ({
                        ...errors,
                        udin:false
                      }))
                    }
                  }
                  }
                  value={updateForm.udin ? updateForm.udin : ""}
                  sx={{ width: "100%" }}
                />
                {errors.udin && <FormHelperText>please enter a proper value!</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel id="transactionVelocity" sx={{ fontSize: "12px" }}>
                  Transaction Velocity
                </FormLabel>
                <RadioGroup
                  id="transactionVelocity"
                  aria-labelledby="transactionVelocity"
                  sx={{ display: "flex", width: "300px", flexDirection: "row" }}
                  onChange={(e) =>
                    setUpdateForm({
                      ...updateForm,
                      transactionVelocity:
                        e.target.value === "true" ? true : false,
                    })
                  }
                  value={updateForm.transactionVelocity}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="YES"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="NO"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel id="isPurposeAllowed" sx={{ fontSize: "12px" }}>
                  Purpose Allowed?
                </FormLabel>
                <RadioGroup
                  id="isPurposeAllowed"
                  aria-labelledby="PurposeAllowed"
                  sx={{ display: "flex", width: "300px", flexDirection: "row" }}
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      isPurposeAllowed:
                        e.target.value === "true" ? true : false,
                    });
                  }}
                  value={updateForm.isPurposeAllowed}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="YES"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="NO"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel id="notAnAdvancePayment" sx={{ fontSize: "12px" }}>
                  AdvancePayment?
                </FormLabel>
                <RadioGroup
                  id="notAnAdvancePayment"
                  sx={{ display: "flex", width: "300px", flexDirection: "row" }}
                  onChange={(e) =>
                    setUpdateForm({
                      ...updateForm,
                      notAnAdvancePayment:
                        e.target.value === "true" ? true : false,
                    })
                  }
                  value={updateForm.notAnAdvancePayment}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="YES"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="NO"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel id="isAgreementNeeded" sx={{ fontSize: "12px" }}>
                  Agreement Needed?
                </FormLabel>
                <RadioGroup
                  id="isAgreementNeeded"
                  sx={{ display: "flex", width: "300px", flexDirection: "row" }}
                  onChange={(e) =>
                    setUpdateForm({
                      ...updateForm,
                      isAgreementNeeded:
                        e.target.value === "true" ? true : false,
                    })
                  }
                  value={updateForm?.isAgreementNeeded}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="YES"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="NO"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: "1rem" }}
              >
                <TransactionFileUpload transactionId={transactionId} productType="OUTWARD"/>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                fullWidth
                sx={{ display: "block", marginTop: "1rem" }}
                required
              >
                <InputLabel id="ad-bank">AD BANK</InputLabel>
                <Select
                  sx={{ width: "300px" }}
                  value={updateForm?.adBankId}
                  onChange={(e) => {
                    setUpdateForm({ ...updateForm, adBankId: e.target.value });
                  }}
                  placeholder="Please Select AD BANK"
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "top",
                      horizontal: "center",
                    },
                  }}
                >
                  {adBankdetails?.map((bank, index) => {
                    return (
                      <MenuItem value={bank.id} key={index}>
                        {bank?.bankName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box
            sx={{
              position: "fixed",
              bottom: "0",
              right: "0",
              width: "100%",
              bgcolor: "#fff",
              borderTop: "1px solid #f2f2f2",
              padding: "1rem",
              textAlign: "right",
            }}
          >
            <DroppedStage
              setShowDroppedTxnModal={setShowDroppedTxnModal}
              showDroppedTxnModal={showDroppedTxnModal}
              setUpdateForm={setUpdateForm}
              updateForm={updateForm}
              transactionId={transactionId}
            />
            <Button
              type="submit"
              variant="contained"
              disabled={updateForm.stageName === "DROPPED" ? true : false}
            >
              Update Transaction
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}
